function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.175.724a.437.437 0 01.439-.437h8.775a.44.44 0 01.438.437c0 .471-.01.92-.03 1.344a2.637 2.637 0 011.73 1.09 2.62 2.62 0 01-1.68 4.081 2.64 2.64 0 01-1.044-.017c-.693 1.632-1.647 2.43-2.485 2.635v1.901l1.25.312c.17.042.33.118.471.223l1.613 1.206a.438.438 0 01-.263.788H2.614a.44.44 0 01-.419-.568.438.438 0 01.156-.22l1.612-1.206c.14-.105.301-.181.472-.223l1.25-.312V9.857C4.847 9.652 3.892 8.854 3.2 7.22A2.64 2.64 0 01.444 6.117a2.62 2.62 0 011.762-4.05c-.02-.447-.031-.895-.03-1.343zm.087 2.223a1.756 1.756 0 00-1.128.727 1.746 1.746 0 00.447 2.435 1.76 1.76 0 001.313.281c-.292-.919-.516-2.053-.632-3.443zM11.11 6.39a1.76 1.76 0 001.313-.281 1.75 1.75 0 00-.681-3.162c-.117 1.391-.341 2.524-.632 3.443z",
  fill: "#FBAD00"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.147 7.687l.488-2.108L4 4.162l2.16-.188L7 1.987l.84 1.987 2.16.188-1.635 1.417.487 2.108L7 6.569 5.147 7.687z",
  fill: "#fff"
});

function SvgTrophy2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgTrophy2;